/**
 * @generated SignedSource<<9cb8824425b989bc582d8e9d19bba942>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ACLPrincipalPicker_principals$data = {
  readonly userGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly roleAssignmentPrincipal: any;
      };
    }> | null | undefined;
  };
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string | null | undefined;
        readonly name: string | null | undefined;
        readonly roleAssignmentPrincipal: any;
      };
    }>;
  };
  readonly " $fragmentType": "ACLPrincipalPicker_principals";
};
export type ACLPrincipalPicker_principals$key = {
  readonly " $data"?: ACLPrincipalPicker_principals$data;
  readonly " $fragmentSpreads": FragmentRefs<"ACLPrincipalPicker_principals">;
};

import ACLPrincipalPickerPrincipalsRefetchQuery_graphql from './ACLPrincipalPickerPrincipalsRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userGroupsFilter"
    },
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "userGroupsFirst"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "usersFilter"
    },
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "usersFirst"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": ACLPrincipalPickerPrincipalsRefetchQuery_graphql
    }
  },
  "name": "ACLPrincipalPicker_principals",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "userGroupsFilter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "userGroupsFirst"
        }
      ],
      "concreteType": "UserGroupConnection",
      "kind": "LinkedField",
      "name": "userGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "usersFilter"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "usersFirst"
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                (v0/*:: as any*/),
                (v1/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "2e19aa5258cd54f723b4bb7ad6b3e145";

export default node;
